import { Model } from './model';

export class Vendor extends Model {
  id: string;

  name: string;
}
